const Z = document.querySelectorAll(".questions__item");

function manageChildrenTabIndex(itemElement, enable) {
  const focusableElements = itemElement.querySelectorAll(
    'a[href], .is-style-stripes, table, tbody, tr, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'
  );

  focusableElements.forEach(el => {
    if (enable) {
      const originalTabIndex = el.dataset.originalTabIndex;
      if (originalTabIndex !== undefined && originalTabIndex !== '') {
        el.setAttribute('tabindex', originalTabIndex);
        delete el.dataset.originalTabIndex;
      } else if (el.getAttribute('tabindex') === '-1') {
        el.removeAttribute('tabindex');
      }
    } else {
      const currentTabIndex = el.getAttribute('tabindex');
      if (currentTabIndex !== '-1' && currentTabIndex !== null) {
        el.dataset.originalTabIndex = currentTabIndex;
      } else if (currentTabIndex === null) {
        el.dataset.originalTabIndex = '';
      }
      el.setAttribute('tabindex', '-1');
    }
  });
}

function toggleAccordionItem(clickedItem) {
  if (clickedItem.classList.contains("active")) {
    clickedItem.classList.remove("active");
    manageChildrenTabIndex(clickedItem, false);
  } else {
    Z.forEach((otherItem) => {
      if (otherItem.classList.contains("active")) {
        otherItem.classList.remove("active");
        manageChildrenTabIndex(otherItem, false);
      }
    });
    clickedItem.classList.add("active");
    manageChildrenTabIndex(clickedItem, true);
  }
}

Z.forEach((item) => {

  if (!item.hasAttribute('tabindex')) {
    item.setAttribute('tabindex', '0');
  }

  if (!item.classList.contains("active")) {
    manageChildrenTabIndex(item, false);
  } else {
    manageChildrenTabIndex(item, true);
  }


  item.addEventListener("click", () => {
    toggleAccordionItem(item);
  });

  item.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleAccordionItem(item);
    }
  });
});
